export class PasswordStrength {
    calculate(password: string): number {
        let strength = 0;

        if (!password) { return 0; }

        if (password.length > 8) {  // check if more than 8 characters
            strength += 25;
        }

        if (password.match(/(?=.*[0-9])/g)) { // check if contains numbers
            strength += 25;
        }

        if (password.match(/(?=.*[a-z])(?=.*[A-Z])/g)) { // check if contains lower and uppercase
            strength += 25;
        }

        if (password.match(/(?=.*[-+_!@#$%^&*.,?])/g)) { // check if contains special characters
            strength += 25;
        }

        return strength;
    }
}